import PublicLayout from '../../../components/public/PublicLayout';
import Hero from '../../../components/public/Hero';
import { NoRealData } from '@/components/shared';

export default function InventoryPage(){return <PublicLayout>
 <Hero title="Inventário da Arborização Urbana" subtitle="Conheça as árvores de Goiânia, por um futuro mais verde." description="Consulta ao inventário da arborização urbana, com espécies, localização, condição fitossanitária e histórico de manejo." />
 <div className="page-pad">
  <NoRealData variant="page" title="Consulta pública ao inventário" description="O inventário ainda não tem consulta pública. Quando for publicado, esta página listará os exemplares arbóreos com espécie, bairro, condição e data da última vistoria validada." icon="ri-plant-line"/>
 </div>
 </PublicLayout>}
